import { Row, Col } from "react-bootstrap";
import Audio from "../../assets/images/AddCreditzAudio.jpg";
import "./Creditztype.css";
import { useState, useEffect } from "react";
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from "@material-ui/core/Typography";
import Box from '@material-ui/core/Box';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Message from "../../components/Message";



const CssTextField = withStyles({
  root: {
    '& label.Mui-focused': {
      color: 'green',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'green',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
       
        borderRadius: '10px',
        marginTop: '10px',
      },
      '&:hover fieldset': {
        borderColor: 'none',
      },
      '&.Mui-focused fieldset': {
        borderColor: 'blue',
        boxShadow: '0px 0px 10px blue'
      }
    },
  },
})(TextField);





const RenderVideo = ({imagelink, allRoles, youtubeUrl, 
  setYoutubeUrl, onBlur, message, music,youtubeSong, 
  setYoutubeSong, videoState, setVideoState, videoFieldsErr}) => {

      // event handler functions 

    function handleUrlChange(event){
      setYoutubeUrl(event.target.value);
      setVideoState({
        type:'url',
        payload:{
          url: event.target.value
        }
      })
    }

    function handleNameChange(event){
      setYoutubeSong(event.target.value);
      setVideoState({
        type:'name',
        payload:{
          name: event.target.value
        }
      })
    }

  return(
    <Paper elevation={3} style={{padding:"20px", borderRadius:"10px"}}>
    <Grid  container direction="column" alignItems='center' spacing={4}>

      <Grid item>
          <Typography variant='h5'>
                Video Details
          </Typography>
      </Grid>

      
      <Grid item >


          <Box style={{ textAlign:'center' }}>
            <img src={imagelink} alt="video" style={{width:"70%", height:"20%"}}></img>
          </Box>
          <Box style={{ textAlign:'center' }}>
          {youtubeUrl === "" ? "": message!==''?   "" :
                    <button onClick={()=>window.open(youtubeUrl)} className="btn btn-primary fw-medium rounded-pill px-3" style={{marginTop:"8px",marginLeft:'5px'}}>
                    View
                     </button>  
           }
          </Box>
      </Grid>
     <Grid item style={{letterSpacing:'3px'}}>
      {message && (
       <Message variant="danger">{message}</Message>
       )}
      </Grid>
     

     

      <Grid item container direction="column"  style={{width:"50%"}} spacing={3}>
        <Grid item>
        <label>What is video URL?</label>
        <CssTextField
         variant='outlined' 
         fullWidth
         size="small"
         value={youtubeUrl}
         onChange={handleUrlChange} 
         onBlur={onBlur}
         />
        </Grid>

        <Grid item>
          <label>What is the video name?</label>
        <CssTextField  

        variant='outlined' 
        fullWidth 
        size="small"
        value={youtubeSong}
        onChange={handleNameChange}
        
        />
        </Grid>
        

        <Grid item>
          <label>What was your role?</label>
        <CssTextField
          id="outlined-select-currency"
          fullWidth
          select
          value={videoState.myRole}
          onChange={(e) => setVideoState({type:'role', payload:{role:e.target.value}})}
          variant="outlined"
          size="small"
          
        >
          {allRoles.map((value) => (
            <MenuItem key={value} value={value}>
              {value}
            </MenuItem>
          ))}
        </CssTextField>


        </Grid>
      </Grid>





    </Grid>
    </Paper>
  )
};



const RenderAudio = ({
  allRoles,
  imagelink,
  updatemusicState,
  music,
  onKeyPress,
  message
}) => {

   const changeHandler = async(event) =>{
    updatemusicState("trackname", event.target.value);
    await onKeyPress();

  }
  return (
    <div className="card border-0 rounded-xl shadow-xs">
      <div style={{ textAlign: "center", marginTop: "12px" }}>
        {" "}
        <h5>Song Details</h5>{" "}
      </div>

      <Row style={{ marginTop: "15px" }}>
        <Col md="5" sm="12" style={{ marginTop: "10px", marginBottom: "10px" }}>
          <div
            className="center"
            style={{ height: "300px", width: "300px", marginTop: "15px" }}
          >
            <img id="center" className="w-100 rounded" src={imagelink}></img>
          </div>
        </Col>
        <Col md="7" sm="12" style={{ marginBottom: "10px" }}>
          <div style={{width: "80%", textAlign: "center" }}>
          {message && (
       <Message variant="danger">{message}</Message>
       )}
          </div>
          <br></br>
          <div className="col-md-10">
            <label
              htmlFor="artistname"
              className="form-label fw-semibold fs-13 text-muted"
            >
              What is the Artist Name?
            </label>
            <input
              type="text"
              className="form-control form-control-lg"
              name="artistname"
              value={music.artistname}
              onChange={(e) => updatemusicState("artistname", e.target.value)}
              // onBlur={onKeyPress}
              // onBlur={albumToastToggle}
              placeholder="Name of Artist"
            />

            <br></br>
            <label
              htmlFor="artistname"
              className="form-label fw-semibold fs-13 text-muted"
            >
              What is the Song Name?
            </label>
            <input
              type="text"
              className="form-control form-control-lg"
              name="songname"
              value={music.trackname}
              onChange={changeHandler }
              // onKeyPress={onKeyPress}
              // onBlur={albumToastToggle}
              placeholder="Name of Song"
            />

            <br></br>
            <label
              htmlFor="artistname"
              className="form-label fw-semibold fs-13 text-muted"
            >
              What is the your Role?
            </label>
            <select
              onChange={(e) => updatemusicState("myrole", e.target.value)}
              className="form-select form-select-lg form-control"
              id="inputmanagement"
            >
              {allRoles.map((role) => (
                <option key={role} value={role}>
                  {role}
                </option>
              ))}
            </select>
          </div>
        </Col>
      </Row>
    </div>
  );
};

const Details = (props) => {
  return (
    <div>
      {props.category == "Music" ? (
        <RenderAudio
          allRoles={props.allRoles}
          imagelink={props.imageLinkAudio}
          updatemusicState={props.updatemusicState}
          music={props.music}
          onKeyPress={props.onKeyPress}
          message={props.message}

        />
      ) : (
        <RenderVideo   
        imagelink={props.imageLinkVideo} 
         allRoles={props.allRoles} 
         youtubeUrl={props.youtubeUrl}
         setYoutubeUrl={props.setYoutubeUrl}
        onBlur={props.onBlur}    
        message={props.videoErrMessage}
        updatemusicState={props.updatemusicState}
        music={props.music}
        youtubeSong={props.youtubeSong}
        setYoutubeSong={props.setYoutubeSong}
        videoState={props.videoState}
        setVideoState={props.setVideoState}
        videoFieldsErr={props.videoFieldsErr}


        />
      )}
    </div>
  );
};

export default Details;
